import ApiService from '@/utils/ApiService'
import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    totalItems: 0,
    agreementOptions: [],
    firmOptions: [],
    bankOptions: [],
    paymentsTypeOptions: [
      { value: 1, text: 'views.exsbpaymentsmade.form.paymentsTypes.cash' },
      { value: 2, text: 'views.exsbpaymentsmade.form.paymentsTypes.bankPayment' },
      { value: 3, text: 'views.exsbpaymentsmade.form.paymentsTypes.electronicPayment' },
      { value: 4, text: 'views.exsbpaymentsmade.form.paymentsTypes.card' },
      { value: 5, text: 'views.exsbpaymentsmade.form.paymentsTypes.voucher' },
      { value: 6, text: 'views.exsbpaymentsmade.form.paymentsTypes.manualTransfer' },
      { value: 8, text: 'views.exsbpaymentsmade.form.paymentsTypes.settlementOverpayment' },
      { value: 9, text: 'views.exsbpaymentsmade.form.paymentsTypes.remission' }
    ]
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    totalItems: (state) => state.totalItems,
    firmOptions (state) {
      return state.firmOptions.map(firm => {
        return {
          value: firm['@id'],
          text: firm.firmname1
        }
      })
    },
    agreementOptions (state) {
      return state.agreementOptions.map(item => {
        return {
          value: item['@id'],
          text: (item.idClient.firmname1 === '' ? item.idClient.fullName : item.idClient.firmname1) + ' (' + (item.number || Vue.prototype.$lang.t('views.agreements.list.noNumber')) + ')' + (item.applicationName ? ' (' + item.applicationName + ')' : '')
        }
      })
    },
    bankOptions (state) {
      return state.bankOptions.map(bank => {
        return {
          value: bank['@id'],
          text: bank.title
        }
      })
    },
    paymentsTypeOptions: (state) => state.paymentsTypeOptions
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    },
    setTotalItems (state, totalItems) {
      state.totalItems = totalItems
    },
    setFirmOptions (state, payload) {
      state.firmOptions = payload
    },
    setAgreementOptions (state, payload) {
      state.agreementOptions = payload
    },
    setBankOptions (state, payload) {
      state.bankOptions = payload
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_s_b_payments_mades') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('setTotalItems', await response.totalItems)
      commit('toggleLoading')
    },
    async fetchFirmOptions ({ commit }) {
      let params = {
        pagination: false,
        isCompany: 1
      }
      const response = await new ApiService('user_datas', params).getResults()
      commit('setFirmOptions', await response.items)
    },
    async fetchAgreementOptions ({ commit }) {
      let params = { pagination: false }
      const response = await new ApiService('e_x_a_b_agreements', params).getResults()
      commit('setAgreementOptions', await response.items)
    },
    async fetchBankOptions ({ commit }) {
      let params = {
        pagination: false
      }
      const response = await new ApiService('e_x_s_b_banks', params).getResults()
      commit('setBankOptions', await response.items)
    }
  }
}
